/* tslint:disable */

/**
 */
export class ViewProcessingReport {
    progress?: string[];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-processing-report.ts